<template>
    <transition name="slide-down">
        <div v-if="showAlert" class="alert-container">
            <div class="alert" :class="alertType">
                <h4>{{ getTranslatedText(alertTitle) }}</h4>
                <p>{{ isTranslate ? getTranslatedText(alertMessage) : alertMessage }}</p>
            </div>
        </div>
    </transition>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
export default {
    mixins: [languageMixins],
    props: {
        showAlert: {
            type: Boolean,
            default: false,
        },
        alertMessage: {
            type: String,
            default: '',
        },
        alertTitle: {
            type: String,
            default: '',
        },
        alertType: {
            type: String,
            default: 'default',
        },
        isTranslate: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/common/alert.scss';
</style>
